import { Injectable } from '@angular/core';
export class ConfirmationGlobalService {
constructor() {}
/**
 * * Return uploaded image File object from selected image URL
 * @param {?} dataurl
 * @param {?} filename
 * @return {?} File
 */
public transformImage(dataurl: string, filename: string): File {
    const /** @type {?} */ splittedURL = dataurl.split(',');
    const /** @type {?} */ mime = splittedURL[0].match(/:(.*?);/)[1];
    const /** @type {?} */ bstr = atob(splittedURL[1]);
    let /** @type {?} */ n = bstr.length;
    const /** @type {?} */ u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ConfirmationGlobalService_tsickle_Closure_declarations() {
/** @type {?} */
ConfirmationGlobalService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ConfirmationGlobalService.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
